export const LOGIN_API = "/api/auth/login";
export const SIGNUP_API = "/api/auth/signup";
export const VIDEO_API = "/api/videos";
export const POST_LIKED_API = "/api/user/likes";
export const GET_LIKED_API = "/api/user/likes";
export const POST_PLAYLIST_API = "/api/user/playlists";
export const POST_HISTORY_API = "/api/user/history";
export const CLEAR_ALL_HISTORY_API = "/api/user/history/all";
export const POST_WATCHLATER_API = "/api/user/watchlater";
